import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { QUERY_KEYS } from 'src/constants'
import { commonService } from 'src/services'
import { IPopularProductsResponse } from 'src/types'

export const useGetPopularProducts = (
  params: { pageSize?: number } = {},
  options?: UseQueryOptions<IPopularProductsResponse>,
) => {
  return useQuery(
    [QUERY_KEYS.GET_POPULAR_PRODUCTS, params],
    () => commonService.getPopularProducts(params),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: 8 * 60 * 1000,
      ...options,
    },
  )
}
